const state = {
  claim: null,
  claims: [],
  processing: false,
};

export default state;
